import React from "react";

const Favorites = () => {
  return (
    <div>
      <h2 className="text-2xl font-bold mb-6">My Favorites</h2>
      <p>This will display all favorited photos.</p>
    </div>
  );
};

export default Favorites;
